import defaultValues from './defaultValues';

// Куда ведёт экран: переходы самого экрана и всех его кнопок
function screenTargets(screen) {
  const targets = [];
  if (screen.screenPath) targets.push(screen.screenPath);

  // Кнопки бывают и в самом экране, и в нижнем блоке — учитываем оба набора,
  // иначе часть переходов теряется и экран ошибочно считается недостижимым
  const buttons = [
    ...(screen.buttons || []),
    ...(screen.bottomBlock?.buttons || []),
  ];

  buttons.forEach((btn) => {
    if (btn.path === 'externalIntegration' && btn.nextScreen) {
      targets.push(btn.nextScreen);
    } else if (btn.path) {
      targets.push(btn.path);
    }
  });

  return targets;
}

// Все экраны, достижимые от заданного (сам экран включён)
export function reachableFrom(screens, screenId) {
  const seen = [];

  const walk = (screen) => {
    if (!screen || seen.includes(screen.screenId)) return;
    seen.push(screen.screenId);
    screenTargets(screen).forEach((id) => walk(screens.find((item) => item.screenId === id)));
  };

  walk(screens.find((item) => item.screenId === screenId));
  return seen;
}

// Экраны, до которых можно дойти от стартового
export function collectReachable(screens) {
  const start = screens.find((item) => item.isStart);
  if (!start) return [];
  return reachableFrom(screens, start.screenId);
}

// Экраны, с которых можно дойти до заданного: переход на них создал бы цикл
export function findAncestors(screens, screenId) {
  return screens
    .filter((item) => item.screenId !== screenId)
    .filter((item) => reachableFrom(screens, item.screenId).includes(screenId));
}

export function findOrphans(screens) {
  const reachable = collectReachable(screens);
  return screens.filter((item) => !reachable.includes(item.screenId));
}

// Куда ведёт кнопка — одним объектом для подписей на схеме и в списке кнопок
// Кнопка настроена не до конца: поток по ней оборвётся
export const BROKEN_KINDS = ['empty', 'missingQueue', 'missingScreen', 'missingNext'];

export const isBrokenTarget = (target) => BROKEN_KINDS.includes(target.kind);

export function describeButtonTarget(button, screens, queues) {
  if (button.params?.name === 'queue' && button.params.value) {
    const queue = queues.find((item) => item.id === Number(button.params.value));
    return queue
      ? { kind: 'queue', label: `очередь «${queue.fullname}»` }
      : { kind: 'missingQueue', label: 'очередь не найдена' };
  }

  // У внешней интеграции есть продолжение — без него поток обрывается, и это надо показать
  if (button.path === 'externalIntegration') {
    if (!button.nextScreen) {
      return { kind: 'missingNext', label: 'внешняя интеграция — не задан экран после неё' };
    }
    const next = screens.find((item) => item.screenId === button.nextScreen);
    return next
      ? { kind: 'action', label: `внешняя интеграция → «${next.headTitle || next.screenId}»` }
      : { kind: 'missingScreen', label: 'внешняя интеграция → экран не найден' };
  }

  const action = defaultValues.buttonActions.find((item) => item.id === button.path);
  if (action) return { kind: 'action', label: action.name };

  if (button.path === 'print') return { kind: 'action', label: 'печать' };

  if (button.path) {
    const target = screens.find((item) => item.screenId === button.path);
    return target
      ? { kind: 'screen', label: `экран «${target.headTitle || target.screenId}»` }
      : { kind: 'missingScreen', label: 'экран не найден' };
  }

  return { kind: 'empty', label: 'без действия' };
}
